import { createLoaderImp } from '../../../../components/ozmoit/common';
import { getCourseFormDataAction } from '../actions';

const {
  useLoaderData: useCourseFormLoaderData,
  LoaderConsumerSimple,
  LoaderProvider,
} = createLoaderImp({
  action: getCourseFormDataAction,
});

function CourseFormLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return (
    <LoaderProvider {...props}>
      <LoaderConsumerSimple>{children}</LoaderConsumerSimple>
    </LoaderProvider>
  );
}

export { CourseFormLoader, useCourseFormLoaderData };
